<div class="categories-container">
  <div class="header d-flex justify-content-start align-items-center">
    <h3 class="fontsize16 font700">{{ 'view_translations.categories' | translate}}</h3>
  </div>
  <ul class="categories-list">
    <app-traffic-source-category-elements [categoriesArray]="categoriesArray" (emitCheckedValues)="getCheckedValues($event)" [isEditMode]="isEditMode">
    </app-traffic-source-category-elements>
  </ul>
  <small *ngIf="submitted && (this.checkedCategories.length < 1)" class="form-text text-danger required-info">
    {{ 'view_translations.this_field_is_required' | translate }}
  </small>
</div>
